import React, { useState } from "react";
import "./LoginComponent.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Button, Card, Form } from "react-bootstrap";
import { apiServices } from "../../service/apiServices";
import UserService from "../../service/UserService";
import jwt_decode from "jwt-decode";

const LoginComponent = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState();
  const [errFlag, setErrFlag] = useState(false);

  const navigate = useNavigate();

  // const handleLogin = (e) => {
  //   // UserService.getUsers();
  //   UserService.doLogin(username, password)
  //     .then(() => {
  //       navigate("/personnel");
  //     })
  //     .catch(() => {
  //       alert("Incorrect Username and Password.");
  //     });
  // };

  const handleLogin = (e) => {
    // UserService.getUsers();
    UserService.doLogin(username, password)
      .then(() => {
        const accessToken = localStorage.getItem("access_token");
        const token = jwt_decode(accessToken);
        const isHR = token?.realm_access?.roles?.includes("facetime_admin");
        if(isHR){
          navigate("/personnel");
        }
        else {
          navigate("/personnelNormal");
        }
      })
      .catch(() => {
        alert("Incorrect Username and Password.");
      });
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      handleLogin(event);
    }
  };

  const usernameChangeHandler = (event) => {
    setUsername(event.target.value);
  };

  const passwordChageHandler = (event) => {
    setPassword(event.target.value);
  };

  return (
    <div className="login-container">
      <Card className="login-content">
        <Card.Body>
          <form>
            {errFlag && <span>{errMsg}</span>}
            <Form.Group>
              <h1>
                <FontAwesomeIcon icon={faUsers} />
              </h1>
              <h1>ATTENDANCE</h1>
              <h1>SYSTEM</h1>
            </Form.Group>

            <Form.Group className="mb-3 mt-3">
              <input
                type="text"
                value={username}
                onChange={usernameChangeHandler}
                placeholder="Username"
                onKeyDown={handleKeyDown}
              />
            </Form.Group>
            <Form.Group className="mb-3 mt-3">
              <input
                type="password"
                value={password}
                onChange={passwordChageHandler}
                placeholder="Password"
                onKeyDown={handleKeyDown}
              />
            </Form.Group>
            <Button
              style={{ backgroundColor: "#3D3D3D" }}
              onClick={handleLogin}
            >
              Login
            </Button>
          </form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default LoginComponent;
